import React from 'react'
import styles from './about-us.scss'
import about_1 from '../../common/images/about/about-1.jpg'
import yd_about from '../../common/images/about/yd-about.png'
import about_tow from '../../common/images/about/about-2.jpg'
import about_3 from '../../common/images/about/about-3.jpg'
import one from '../../common/images/solution/01.png'
import two from '../../common/images/solution/02.png'
import three from '../../common/images/solution/03.png'
// import group from '../../common/images/about/group.png'
import group_yd from '../../common/images/about/group-yd.png'
// import major from '../../common/images/about/major.png'
import major_yd from '../../common/images/about/major-yd.png'
import address from '../../common/images/about/address.jpg'
import addressPC from '../../common/images/about/address-pc.jpg'
import chapterPc from '../../common/images/about/chapter-pc.jpg'
import chapter from '../../common/images/about/chapter.jpg'
const AboutUs = (props) => {
  return <section className={styles['about-us']}>
    <div className={styles['about-contnet']}>
      <div className={styles['about-1']}>
        <div>
          <h2>智能财税SAAS服务商</h2>
          <p>为代理记账公司、中小企业提供智能财税软件及高端增值业务</p>
          <p>打造一体化智能解决方案</p>
        </div>
        <img src={about_1} alt='about_1' className={styles['about_one']} />
        <img src={yd_about} alt='yd-about' className={styles['yd-about']} />
      </div>
      <div className={styles['about']}>
        <img src={about_3} alt='about_3' />
        <div className={styles['about-us-s']}>
          <h3>About Us</h3>
          <h4>概而论网络科技有限公司</h4>
          <p>
            概而论是一家以云计算、大数据分析、WEB应用开发、软件开发、人工智能及互联网平台运营为核心技术的科技公司，致力于以数字化手段重塑财税服务生态。旗下"云代账"与"云生态"两大SaaS产品专为代账行业定制，帮助代账公司完善内控体系、优化成本结构，更以丰富的生态产品为代账公司开辟多元化经营新赛道。
          </p>
          <p>
            概而论自2023年起深度参与电子凭证会计数据标隹深化试点工作，打通了电子凭证从采集、处理到归档的全流程，推动会计工作实现标准化、无纸化转型。2025年，公司成功入选财政部与中国人民银行联合发起的《小微企业增信会计数据标准》深化试点单位，跻身全国仅八家试点会计软件服务商之列。
          </p>
          <p>
            概而论已在杭州、上海、成都、武汉、长沙、合肥、重庆、宁波等重点城市布局服务中心，业务覆盖33个省级行政区，累计服务近百万家企事业单位。公司始终以"为客户创造价值"为使命，持续探索与创新，深度打造财税行业全场景数字化解决方案，助力企业数字化转型与高质量发展。
          </p>
        </div>
      </div>
      <div className={styles['address_yd']} >
        <img src={address} alt='address_yd' />
      </div>
      <div className={styles['statistic_yd']}>
        <div className={styles['statistic']}>
          <div className={`${styles['number']} ${styles['orange']}`}>33</div>
          <div className={styles['description']}>支持33个省份和自治区</div>
        </div>
        <div className={styles['statistic']}>
          <div className={`${styles['number']} ${styles['blue']}`}><span>近</span>100W</div>
          <div className={styles['description']}>为近百万客户提供服务</div>
        </div>
      </div>
      <div className={styles['chapter_yd']} >
        <img src={chapter} alt='chapter_yd' />
      </div>
      <div className={styles['advantage']}>
        <div>
          {/* <img src={group} alt='group' className={styles['group']} /> */}
          <img src={group_yd} alt='group_yd' className={styles['group_yd']} />
        </div>
        <ul>
          <li>
            <div><img src={one} alt='one' /></div>
            <h3>专业的团队</h3>
            <span></span>
            <div className={styles['advantage_content']}>
              <p>我们依托核心团队的卓越研发实力，已斩获30多项软著认证。作为国家电子凭证会计数据标准深化试点的参与方，我们积累了宝贵经验。如今，我们更将前沿AI技术融入财税全链路，旨在为您提供更合规、更高效的财税解决方案，让复杂的财税工作步入“智”能管理时代。</p>
            </div>
          </li>
          <li>
            <div><img src={two} alt='two' /></div>
            <h3>丰富的经验</h3>
            <span className={styles['advantage_bgOne']}></span>
            <div className={styles['advantage_content']}>
              <p>概而论深耕SaaS财税领域，凭借扎实的技术与丰富的实践经验，获财政部会计司和中国人民银行信贷市场司认可，入选《小微企业增信会计数据标准深化试点》试点服务商。我们长期服务于各类财税公司及中小微企业，积累了深厚多元的实战经验，可精准匹配不同业务场景。</p>
            </div>
          </li>
          <li>
            <div><img src={three} alt='three' /></div>
            <h3>我们的模式</h3>
            <span className={styles['advantage_bgTwo']}></span>
            <div className={styles['advantage_content']}>
              <p>概而论采用SaaS模式，免安装、免维护、免备份，有网即可用。我们推出高度适配各类财税机构与企业的差异化版本，确保每一类客户都能获得精准匹配的服务。同时，面对不断变化的政策法规与业务需求，概而论持续优化功能，实现无感迭代升级，让产品使用更便捷智能。</p>
            </div>
          </li>
        </ul>
        <div className={styles['major']}>
          {/* <img src={major} alt='major' /> */}
        </div>
        <div className={styles['address']} >
          <img src={addressPC} alt='address' />
        </div>
        <div className={styles['chapter']} >
          <img src={chapterPc} alt='chapter' />
        </div>
        <div className={styles['major_yd']}>
          <img src={major_yd} alt='major_yd' className={styles['major_yd']} />
        </div>
      </div>
      <div className={styles['about_tow']}>
        <img src={about_tow} alt='about_tow' className={styles['about_img']} />
      </div>
    </div>
    <div className={styles['about-contnet_x']}>
    </div>
  </section>
}

export default AboutUs
